/*
 * streets Actions
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 27-May-2025
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  // @generator action:type
  // @generator action:type:request
  DO_GET_COUNTRIES: '@@address/get_countries',
  DO_GET_STREETS: '@@address/get_streets',
  DO_GET_PROVINCES: '@@address/get_provinces',
  DO_GET_MUNICIPALITIES: '@@address/get_municipalities',
  DO_GET_CHECK_FOREIGN_MUNICIPALITIES: '@@address/get_check_foreign_municipalities',
  RESET_CHECK_FOREIGN_MUNICIPALITIES_ERROR: '@@address/reset_check_foreign_municipalities',
  ...createRequestTypes('@@address', 'GET_COUNTRIES'),
  ...createRequestTypes('@@address', 'GET_STREETS'),
  ...createRequestTypes('@@address', 'GET_PROVINCES'),
  ...createRequestTypes('@@address', 'GET_MUNICIPALITIES'),
  ...createRequestTypes('@@address', 'GET_CHECK_FOREIGN_MUNICIPALITIES')
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action

/** @action request
 * * Insert a description
 * @name getCountries
 * @return {object} - The action object
 */
export const getCountries = new MakeRequest('address', 'get_countries')
/** @action request
 * * Insert a description
 * @name getStreets
 * @return {object} - The action object
 */
export const getStreets = new MakeRequest('address', 'get_streets')
/** @action request
 * * Insert a description
 * @name getCities
 * @return {object} - The action object
 */
export const getMunicipalities = new MakeRequest('address', 'get_municipalities')
/** @action request
 * * Insert a description
 * @name getProvinces
 * @return {object} - The action object
 */
export const getProvinces = new MakeRequest('address', 'get_provinces')
/** @action request
 * * Insert a description
 * @name getCheckForeignMunicipalities
 * @return {object} - The action object
 */
export const getCheckForeignMunicipalities = new MakeRequest('address', 'get_check_foreign_municipalities')

/** @action
 * * Insert a description
 * @name doGetCountries
 * @return {object} - The payload object
 */
export const doGetCountries = (payload) => createAction(actionTypes.DO_GET_COUNTRIES, { payload })
/** @action
 * * Insert a description
 * @name doGetStreets
 * @return {object} - The payload object
 */
export const doGetStreets = (payload) => createAction(actionTypes.DO_GET_STREETS, { payload })
/** @action
 * * Insert a description
 * @name doGetCities
 * @return {object} - The payload object
 */
export const doGetMunicipalities = (payload) => createAction(actionTypes.DO_GET_MUNICIPALITIES, { payload })
/** @action
 * * Insert a description
 * @name doGetProvinces
 * @return {object} - The payload object
 */
export const doGetProvinces = (payload) => createAction(actionTypes.DO_GET_PROVINCES, { payload })
/** @action
 * * Insert a description
 * @name doGetCheckForeignMunicipalities
 * @return {object} - The payload object
 */
export const doGetCheckForeignMunicipalities = (payload) => createAction(actionTypes.DO_GET_CHECK_FOREIGN_MUNICIPALITIES, { payload })
/** @action
 * * Insert a description
 * @name resetCheckForeignMunicipalities
 * @return {object} - The payload object
 */
export const resetCheckForeignMunicipalities = (payload) => createAction(actionTypes.RESET_CHECK_FOREIGN_MUNICIPALITIES_ERROR, { payload })
// ------------------------------------
